import React from 'react'

const BlurBlueDecorationSmall = () => {
    return (
        <div className='blur-blue-decoration-small'></div>
    )
}

export default BlurBlueDecorationSmall